import React from 'react';
import PropTypes from 'prop-types';

import ContactInfo from './contact_info';
import Email from './email';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export default class CompanyForm extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      additionalEmails: PropTypes.array.isRequired,
      addresses: PropTypes.array.isRequired,
      email: PropTypes.string,
      name: PropTypes.string,
      phoneNumbers: PropTypes.array.isRequired,
      website: PropTypes.string
    }),
    extraSections: PropTypes.node,
    onChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="form-horizontal">
        {this.renderCompanyInfo()}
        {this.renderContactInfo()}
        {this.props.extraSections}
      </div>
    );
  }

  renderCompanyInfo() {
    return <React.Fragment>
      <h3 className="mt-0">Company & website</h3>
      {this.renderFormGroup('name', 'Company name', { placeholder: 'Type company name', required: true })}
      {this.renderFormGroup('website', 'Company website', { placeholder: 'Type company website' })}
    </React.Fragment>;
  }

  renderContactInfo() {
    return <React.Fragment>
      <h3>Contact information</h3>

      <Email
        contact={this.props.contact}
        onChange={this.props.onChange}
      />

      <ContactInfo
        addresses={this.props.contact.addresses}
        phoneNumberLabels={['Main', 'Fax']}
        phoneNumbers={this.props.contact.phoneNumbers}
        onChange={this.props.onChange}
      />
    </React.Fragment>;
  }

  renderFormGroup(name, label, props = {}) {
    return (
      <ManagedFormGroup
        autoComplete="off"
        label={label}
        name={name}
        value={this.props.contact[name]}
        onChange={this.props.onChange}
        {...props}
      />
    );
  }
}
